import React, { Component } from "react";
import Header from "./userTableHeader";
import TableData from "./userTableData";
import { Row, Col, Spin } from "antd";

export default class userListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      ShowGlobalSearch: false,
      ComponentKey: 1,
      TableDataComponentKey: 1,
      SearchExternal: false,
      headers: [],
      currentTab: "ActiveUsers",
      currentPage: 1,
      rowsPerPage: 100,
      totalRowCount: 0,
      filterdata: [],
      onSelectAllDATA:[],
      tabledata: this.props.tableData,
      SortTable: this.props.tableData,
      tablestate: false,

      deletedSingleUserlist:false,

      selectedRows: [], // add this if not using props.selectedRows
      selectAllchex:false,

      filter: {
        UserName: "",
        Email: "",
        ApprovedBy: "",
        PhoneNumber: "",
        Address: "",
        DateOfBirth: "",
        Roles: "",
        RegistrationID: "",
        CreatedDate: "",
        FullName: "",
        ContactNumber: "",
        EmailID: "",
        Status: "",
        TaxID: "",
        AccessLevel: ""
      },
      sort: {
        column: null,
        direction: "asc",
      },
    };
  }
  componentDidMount() {
    console.log(this.props)
    this.setState({
      tabledata: this.props.tableData,
    });
    
  }

  handleSearchExternal = (value) => {
    this.setState({ SearchExternal: value });
  };
  handleShowGlobalSearch = (value) => {
    this.setState({ ShowGlobalSearch: value, SearchExternal: value });
  };
  resetFilter = () => {
    this.setState({ ComponentKey: this.state.ComponentKey + 1 });
    this.props.resetFilter();
    this.props.handleshowPagination(true);
  };
  getpaginationData = (allRows, currentPage) => {
    // console.log(allRows)
    const indexOfLastRow = currentPage * this.state.rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - this.state.rowsPerPage;
    const currentPageData = allRows.slice(indexOfFirstRow, indexOfLastRow);
    return currentPageData;
  };
  filters = (fname, value) => {
    this.setState({ filterdata: [] });
    this.props.handleSetField(fname, value);
    if (fname === "UserName") {
      this.state.filter.UserName = value;
    } else if (fname === "Email") {
      this.state.filter.Email = value;
    } else if (fname === "ApprovedBy") {
      this.state.filter.ApprovedBy = value;
    } else if (fname === "PhoneNumber") {
      this.state.filter.PhoneNumber = value;
    } else if (fname === "Address") {
      this.state.filter.Address = value;
    } else if (fname === "DateOfBirth") {
      this.state.filter.DateOfBirth = value;
    } else if (fname === "Roles") {
      this.state.filter.Roles = value;
    } else if (fname === "RegistrationID") {
      this.state.filter.RegistrationID = value;
    } else if (fname === "CreatedDate") {
      this.state.filter.CreatedDate = value;
    } else if (fname === "FullName") {
      this.state.filter.FullName = value;
    } else if (fname === "ContactNumber") {
      this.state.filter.ContactNumber = value;
    } else if (fname === "EmailID") {
      this.state.filter.EmailID = value;
    } else if (fname === "Status") {
      this.state.filter.Status = value;
    } else if (fname === "TaxID") {
      this.state.filter.TaxID = value;
    } else if (fname === "AccessLevel"){
      this.state.filter.AccessLevel = value;
    }
    // console.log("fname", fname, "value ", value);

    if (this.props.activeTab === "ActiveUsers") {
      this.state.filterdata = this.state.tabledata.filter((e) => {
        e.UserName = e.providerName === null ? "" : e.UserName;
        e.Email = e.providerName === null ? "" : e.Email;
        e.ApprovedBy = e.providerName === null ? "" : e.ApprovedBy;
        e.CreatedDate = e.CreatedDate === null ? "" : e.CreatedDate;
        e.PhoneNumber = e.PhoneNumber === null ? "" : e.PhoneNumber;
        e.Address = e.Address === null ? "" : e.Address;
        e.DateOfBirth = e.DateOfBirth === null ? "" : e.DateOfBirth;
        e.Roles = e.Roles === null ? "" : e.Roles;

        return (
          e.UserName.toLowerCase().includes(
            this.state.filter.UserName.toLowerCase()
          ) &&
          e.Email.toLowerCase().includes(
            this.state.filter.Email.toLowerCase()
          ) &&
          e.ApprovedBy.toLowerCase().includes(
            this.state.filter.ApprovedBy.toLowerCase()
          ) &&
          (
            !this.state.filter.CreatedDate ||
            new Date(e.CreatedDate).toDateString() ===
              new Date(this.state.filter.CreatedDate).toDateString()
          ) &&
          
          e.PhoneNumber.toLowerCase().includes(
            this.state.filter.PhoneNumber.toLowerCase()
          ) &&
          e.Address.toLowerCase().includes(
            this.state.filter.Address.toLowerCase()
          ) &&
          e.DateOfBirth.includes(this.state.filter.DateOfBirth) &&
          e.Roles.toLowerCase().includes(this.state.filter.Roles.toLowerCase())
        );
      });
    }
    // Filtering table based on input data.......................
    else {
      this.state.filterdata = this.state.tabledata.filter((e) => {
        let RegistrationID =
          e.RegistrationID === null ? "" : e.RegistrationID.toString();
        e.CreatedDate = e.CreatedDate === null ? "" : e.CreatedDate;
        e.FullName = e.FullName === null ? "" : e.FullName;
        e.ContactNumber = e.ContactNumber === null ? "" : e.ContactNumber;
        e.EmailID = e.EmailID === null ? "" : e.EmailID;
        e.Status = e.Status === null ? "" : e.Status;
        e.TaxID = e.TaxID === null ? "" : e.TaxID;
        e.AccessLevel = e.AccessLevel === null ? "" : e.AccessLevel;
        return (
          RegistrationID.includes(this.state.filter.RegistrationID) &&
          e.CreatedDate.toLowerCase().includes(
            this.state.filter.CreatedDate.toLowerCase()
          ) &&
          e.FullName.toLowerCase().includes(
            this.state.filter.FullName.toLowerCase()
          ) &&
          e.ContactNumber.toLowerCase().includes(
            this.state.filter.ContactNumber.toLowerCase()
          ) &&
          e.EmailID.toLowerCase().includes(
            this.state.filter.EmailID.toLowerCase()
          ) &&
          e.Status.toLowerCase().includes(
            this.state.filter.Status.toLowerCase()
          ) &&
          e.TaxID.toLowerCase().includes(this.state.filter.TaxID.toLowerCase()) &&
          e.AccessLevel.toLowerCase().includes(this.state.filter.AccessLevel.toLowerCase())
        );
      });
    }
    if (this.state.filterdata.length !== this.state.tabledata.length) {
      this.setState({ tablestate: true })
    } else {
      this.setState({ tablestate: false })
    }
    this.setState(
      {
        SortTable: this.state.filterdata,
        filterdata: this.state.filterdata,
      },
      () => {
        // Object.keys(this.state.filter).filter(item =>
        //   this.state.filter[item]).length > 0 ?
        //   this.props.handleshowPagination(false) :
        //   this.props.handleshowPagination(true)
        if (
          Object.keys(this.state.filter).filter(
            (item) => this.state.filter[item]
          ).length > 0 &&
          this.props.activeTab === "ActiveUsers"
        ) {
          this.handleShowGlobalSearch(true);
          this.props.handleshowPagination(false);
          // if(!this.state.SearchExternal){
          //   this.handleShowGlobalSearch(true)
          // }
        } else {
          this.handleShowGlobalSearch(false);
          this.props.handleshowPagination(true);
        }
      }
    );
  };
  tableSortresult = (column) => {
    // console.log(this.state.sort.direction);
    const direction = this.state.sort.direction === "desc" ? "asc" : "desc";
    let sortedData;
    if (this.props.activeTab !== "RegisteredUsers") {
      this.state.SortTable = this.props.tableData;
      sortedData = this.state.SortTable.sort((a, b) => {
        if (
          column === "UserName" ||
          column === "Email" ||
          column === "ApprovedBy" ||
          column === "CreatedDate" ||
          column === "PhoneNumber" ||
          column === "Address" ||
          column === "DateOfBirth" ||
          column === "Roles"
        ) {
          const nameA =
            column === "UserName"
              ? a.UserName === null
                ? ""
                : a.UserName.toUpperCase()
              : column === "Email"
                ? a.Email === null
                  ? ""
                  : a.Email.toUpperCase()
                  : column === "ApprovedBy"
                  ? a.ApprovedBy === null
                    ? ""
                    : a.ApprovedBy.toUpperCase()
                    : column === "CreatedDate"
                    ? a.CreatedDate === null
                      ? ""
                      : a.CreatedDate.toUpperCase()
                : column === "PhoneNumber"
                  ? a.PhoneNumber === null
                    ? ""
                    : a.PhoneNumber.toUpperCase()
                  : column === "Address"
                    ? a.Address === null
                      ? ""
                      : a.Address.toUpperCase()
                    : column === "DateOfBirth"
                      ? a.DateOfBirth === null
                        ? ""
                        : new Date(a.DateOfBirth)
                      : a.Roles.toUpperCase();

          // Column B starts from here..............
          const nameB =
            column === "UserName"
              ? b.UserName === null
                ? ""
                : b.UserName.toUpperCase()
              : column === "Email"
                ? b.Email === null
                  ? ""
                  : b.Email.toUpperCase()
                  : column === "ApprovedBy"
                  ? b.ApprovedBy === null
                    ? ""
                    : b.ApprovedBy.toUpperCase()
                    : column === "CreatedDate"
                    ? b.CreatedDate === null
                      ? ""
                      : b.CreatedDate.toUpperCase()
                : column === "PhoneNumber"
                  ? b.PhoneNumber === null
                    ? ""
                    : b.PhoneNumber.toUpperCase()
                  : column === "Address"
                    ? b.Address === null
                      ? ""
                      : b.Address.toUpperCase()
                    : column === "DateOfBirth"
                      ? b.DateOfBirth === null
                        ? ""
                        : new Date(b.DateOfBirth)
                      : b.Roles.toUpperCase();

          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        } else {
          return a.column - b.column;
        }
      });
    }
    if (this.props.activeTab === "RegisteredUsers") {
      this.state.SortTable = this.props.tableData;
      sortedData = this.state.SortTable.sort((a, b) => {
        if (
          column === "RegistrationID" ||
          column === "CreatedDate" ||
          column === "FullName" ||
          column === "ContactNumber" ||
          column === "EmailID" ||
          column === "Status" ||
          column === "TaxID"
        ) {
          const nameA =
            column === "RegistrationID"
              ? a.RegistrationID === null || a.RegistrationID === ""
                ? -99999999
                : parseInt(a.RegistrationID)
              : column === "CreatedDate"
                ? a.CreatedDate === null
                  ? ""
                  : new Date(a.CreatedDate)
                : column === "FullName"
                  ? a.FullName === null
                    ? ""
                    : a.FullName.toUpperCase()
                  : column === "ContactNumber"
                    ? a.ContactNumber === null
                      ? ""
                      : a.ContactNumber.toUpperCase()
                    : column === "EmailID"
                      ? a.EmailID === null
                        ? ""
                        : a.EmailID.toUpperCase()
                      : column === "Status"
                        ? a.Status === null
                          ? ""
                          : a.Status.toUpperCase()
                        : a.TaxID.toUpperCase();

          // Column B starts from here..............
          const nameB =
            column === "RegistrationID"
              ? b.RegistrationID === null || b.RegistrationID === ""
                ? -99999999
                : parseInt(b.RegistrationID)
              : column === "FullName"
                ? b.FullName === null
                  ? ""
                  : b.FullName.toUpperCase()
                : column === "ContactNumber"
                  ? b.ContactNumber === null
                    ? ""
                    : b.ContactNumber.toUpperCase()
                  : column === "EmailID"
                    ? b.EmailID === null
                      ? ""
                      : b.EmailID.toUpperCase()
                    : column === "Status"
                      ? b.Status === null
                        ? ""
                        : b.Status.toUpperCase()
                      : column === "CreatedDate"
                        ? b.CreatedDate === null
                          ? ""
                          : new Date(b.CreatedDate)
                        : b.TaxID.toUpperCase();

          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        } else {
          return a.column - b.column;
        }
      });
    }
    // console.log(sortedData);
    if (direction === "asc") {
      sortedData.reverse();
    }
    this.setState({
      sort: {
        column,
        direction,
      },
    });
  };

  getGlobalUsers = async (SearchGlobal) => {
    this.setState({ loader: true, tablestate: false });
    await this.props.getListUser("ActiveUsers", 1, SearchGlobal);

    this.setState({
      SearchExternal: true,
      TableDataComponentKey: this.state.TableDataComponentKey + 1,
      loader: false,
    });
  };

  onSelectRow = (row) => {
    let newSelectedRows = [];
    if (this.props.selectedRows.includes(row)) {
      newSelectedRows = this.props.selectedRows.filter(r => r !== row);
    } else {
      newSelectedRows = [...this.props.selectedRows, row];
    }
  
    if (this.props.onUpdateSelectedRows) {
      this.props.onUpdateSelectedRows(newSelectedRows);
    }
  };
  
  onSelectAll = () => {
    const { tableData, selectedRows } = this.props;
    let newSelectedRows = [];
  
    if (selectedRows.length === tableData.length) {
      newSelectedRows = []; // deselect all
    } else {
      newSelectedRows = [...tableData]; // select all
    }
  
    if (this.props.onUpdateSelectedRows) {
      this.props.onUpdateSelectedRows(newSelectedRows);
    }
  };
  

 
 

   
    
  
  render() {
    this.state.deletedSingleUserlist = this.props.deletedSingleUser
    this.state.tabledata = this.props.tableData;
    let renderRows;
    if(this.state.currentTab !== this.props.activeTab){
      this.state.ShowGlobalSearch = false;
      this.state.SearchExternal = false;
      this.state.tablestate = false;
      this.state.filterdata = this.props.tableData;
      this.state.currentTab = this.props.activeTab;
      this.state.filter = {
        UserName: "",
        Email: "",
        ApprovedBy: "",
        PhoneNumber: "",
        Address: "",
        DateOfBirth: "",
        Roles: "",
        RegistrationID: "",
        CreatedDate: "",
        FullName: "",
        ContactNumber: "",
        EmailID: "",
        Status: "",
        TaxID: "",
        AccessLevel: ""
      }
      renderRows = this.props.tableData
    }
    else if (this.state.tablestate === false) {
      renderRows = this.state.tabledata;
    } else {
      renderRows = this.state.filterdata;
    }

    if (this.props.updateTable) {
      renderRows = this.props.tableData;
    }

     if(renderRows.length !== 0){
      this.state.deletedSingleUserlist = false
     }
    //console.log("renderRows -1", renderRows)

    return (
      <div>
        <table className="table">
          <Header
            key={this.state.ComponentKey}
            headers={this.props.headers}
            filters={this.filters}
            tableSort={this.tableSortresult}
          // filtertext={this.state.TextValue}
          />
          {(this.state.ShowGlobalSearch || this.state.SearchExternal) && (
            <tr className="nobg">
              <td colspan="6">
                <Row className="my-3 mx-1" type="flex" justify="space-between">
                  <Col>
                    <div className="external-search">
                      <div>
                        <span style={{ fontSize: "14px" }}>
                          <b>
                            You can search by any value from the top by clicking
                            on
                          </b>
                        </span>
                        <span>
                          <button
                            className="button-alluser px-3 mx-1"
                            onClick={() => this.getGlobalUsers("SearchGlobal")}
                          >
                            Search for Users
                          </button>
                        </span>
                        {this.state.isLoading && (
                          <span className="ml-2">
                            <Spin size="small" />
                          </span>
                        )}
                      </div>
                    </div>
                  </Col>
                  {this.state.SearchExternal && (
                    <Col>
                      <div className="mt-2">
                        <button
                          className="delete-alluser danger pl-4 pr-4"
                          onClick={() => this.resetFilter()}
                        >
                          Reset
                        </button>
                      </div>
                    </Col>
                  )}
                </Row>
              </td>
            </tr>
          )}
            <tr className="nobg">
              <td colspan="4">
                <Row className="my-3 mx-1" type="flex" justify="space-between">

                { (renderRows.length > 0 && this.props.showRegisteredSelectAllButt) &&
                  <Col >
                    <div className="external-search">
                      <button
                        className="button-alluser px-3 mx-1"
                        onClick={() => this.onSelectAll(renderRows)}
                      >
                      {(this.props.tableData.length == this.props.selectedRows.length) ? "Deselect All" : "Select All"}
                      </button>
                    </div>
                  </Col>
                  }
                {(this.props.selectedRows.length > 0 && this.props.showActiveUserListButt) &&
                  <Col style={{marginRight:"100px"}}>
                    <div className="external-search">
                      <button
                        className="button-alluser px-3 mx-1"
                        onClick={this.props.onOpenModal}
                      >
                        Activate Users
                      </button>
                    </div>
                  </Col>
                }     
                </Row>
              </td>
            </tr>
          
          {(!this.state.loader || !this.props.loader2) && (
            <TableData
              resetSelectedRows = {this.props.resetSelectedRows}
              selectedRows={this.props.selectedRows} 
              onSelectRow={this.onSelectRow}
              selectall={this.state.selectAllchex}
              activeTab={this.props.activeTab}
              key={this.state.TableDataComponentKey}
              data={renderRows}
              header={this.props.headers}
              getType={this.props.getType}
              currentPage={this.props.currentPage}
              limit={this.props.limit}
              DeleteUserCallBack={this.props.DeleteUserCallBack}
              handleSearchExternal={this.handleSearchExternal}
            />
          )}
        </table>
        {((!renderRows || renderRows.length === 0) && !this.props.loader2 && !this.state.deletedSingleUserlist) && (
          <Row>
            <Col span={24}>
              <h4 className="mt-5" style={{ textAlign: "center" }}>
                {" "}
                No records found !{" "}
              </h4>
            </Col>
          </Row>
        )}


        { ( this.state.deletedSingleUserlist)&& (
          <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
            <Spin size="large" tip="Loading..." />
          </div>
        )}

        {(this.state.loader || this.props.loader2) && ( !this.state.deletedSingleUserlist) && (
          <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
            <Spin size="large" tip="Loading..." />
          </div>
        )}
      </div>
    );
  }
}
